import { Fragment } from 'react';
import { useRef } from '@wordpress/element';
import smoothscroll from 'smoothscroll-polyfill';
import useIsMobile from '../hooks/useIsMobile';
import Menu from './Menu';
import MobileMenu from './MobileMenu';
import BarTable from './Table';

import { Button, Icon } from 'semantic-ui-react';

const App = () => {
	const isMobile = useIsMobile();
	const myRef = useRef(null);
	const myTable = useRef(null);

	const scrollToTheTop = () => {
		myRef.current.scrollIntoView({ behavior: 'smooth' });
		smoothscroll.polyfill();
	};

	return (
		<Fragment>
			<div id="comparison-intro" className="comparison-intro">
				{/* <img class="header-image" src={headerImage} /> */}
				<p>
					Pew Research Center’s political typology sorts Americans
					into cohesive, like-minded groups based on their values,
					beliefs, and views about politics and the political system.
				</p>
				<p>
					Use this tool to compare the groups on some key topics or by
					demographics.
				</p>
			</div>
			<div id="comparison-menu" ref={myRef}>
				{isMobile ? <MobileMenu /> : <Menu myTable={myTable} />}
			</div>
			<div id="comparison-table" ref={myTable}>
				<BarTable />
			</div>
			<div id="comparison-footer">
				<Button className="back-up" onClick={() => scrollToTheTop()}>
					Back to menu
					<Icon name="arrow alternate circle up" />
				</Button>
			</div>
			<div id="comparison-outro" className="notes">
				<p>
					Take the{' '}
					<a href="http://www.people-press.org/quiz/political-typology/">
						{' '}
						Political Typology Quiz
					</a>{' '}
					to learn which of the types is your best match.
				</p>
				<p>
					Read the report:{' '}
					<a href="https://www.pewresearch.org/politics/2026/06/10/beyond-red-vs-blue-the-political-typology/">
						{' '}
						Beyond Red vs. Blue: The Political Typology
					</a>
				</p>
				<p>
					No answer responses and estimates below 1% are not shown.
					Refer to the{' '}
					<a href="https://docs.google.com/spreadsheets/d/1jF_J-rdaI6tAROKKMlTqKEz2eOIpTwlPpBOmrS9vWQw/edit?usp=sharing">
						{' '}
						detailed tables
					</a>{' '}
					for full question wording.
				</p>
			</div>
			<br style={{ clear: 'both' }} />
		</Fragment>
	);
};

export default App;
